function setupNavMenu(){
//open navigation menu
  const menuToggle = document.getElementById('nav-menu-toggle');
//  const menu = document.getElementById('nav-menu');
  const menuClose = document.getElementById('nav-menu-close');

  if(menuToggle){
    const open = () =>{
      document.body.classList.add('modal-open', 'nav-menu-open');
    }

    const close = () => {
      document.body.classList.add('nav-menu-closing');
      setTimeout(()=>{
        document.body.classList.remove('nav-menu-closing');
      }, 2000);

      document.body.classList.remove('modal-open', 'nav-menu-open');
      document.body.style.paddingRight = "";
    }

    if(menuClose){
      menuClose.addEventListener('click', ev => {
        ev.preventDefault();
        ev.stopPropagation();
        close();
      })
    }

    menuToggle.addEventListener('click', ev =>{
      ev.preventDefault();
      ev.stopPropagation();
      document.body.classList.contains('nav-menu-open') ? close() : open();
    })
  }
}

(fn => (document.readyState !== 'loading') ? fn() : document.addEventListener('DOMContentLoaded', fn))(()=>{
  setupNavMenu();
})
